var BpamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ObjectUtils } from "../../utils/object-utils";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../../shared/utils/recipient-utils";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiBuildingPlansConstants } from "../../constants/api-constants/api-building-plans.constants";
import { CreateApplicationLocationBpamsComponent } from "../../../create-application/modules/bp/create-application-location-bpams/create-application-location-bpams.component";
import { CreateApplicationDetailsBpamsComponent } from "../../../create-application/modules/bp/create-application-details-bpams/create-application-details-bpams.component";
import { CreateApplicationProfessionalBodiesBpamsComponent } from "../../../create-application/modules/bp/create-application-professional-bodies-bpams/create-application-professional-bodies-bpams.component";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ViewApplicationDetailsBpamsComponent } from "../../../view-application/modules/bp/view-application-details-bpams/view-application-details-bpams.component";
import { ViewApplicationLocationBpamsComponent } from "../../../view-application/modules/bp/view-application-location-bpams/view-application-location-bpams.component";
import { ViewApplicationProfessionalBodiesBpamsComponent } from "../../../view-application/modules/bp/view-application-professional-bodies-bpams/view-application-professional-bodies-bpams.component";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { CreateApplicationLocationBpamsConstants } from "../../../create-application/modules/bp/create-application-location-bpams/create-application-location-bpams.constants";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ErfNumber, "erfNumbers"],
    [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.CreatedDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const BPExpandListForApplicationPartial = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_BP;
export var CreateApplicationBpamsMenuHeadings;
(function (CreateApplicationBpamsMenuHeadings) {
    CreateApplicationBpamsMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationBpamsMenuHeadings["Location"] = "Property";
    CreateApplicationBpamsMenuHeadings["Details"] = "Application";
    CreateApplicationBpamsMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationBpamsMenuHeadings["Agent"] = "Agent";
    CreateApplicationBpamsMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    CreateApplicationBpamsMenuHeadings["Notes"] = "Notes";
    CreateApplicationBpamsMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationBpamsMenuHeadings || (CreateApplicationBpamsMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Property help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["ProfessionalBodies"] = "Professional bodies help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationBpamsMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationBpamsMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationBpamsMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationBpamsMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationBpamsMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationBpamsMenuHeadings.ProfessionalBodies, HeaderConfigurableTextTypes.ProfessionalBodies)
    .set(CreateApplicationBpamsMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationBpamsMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationBpamsMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Application status";
    ViewApplicationMenuHeadings["Location"] = "Property";
    ViewApplicationMenuHeadings["Details"] = "Application";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["ProfessionalBodies"] = "Professional bodies";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.ProfessionalBodies, HeaderConfigurableTextTypes.ProfessionalBodies)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let BpamsStrategyService = class BpamsStrategyService extends AflaModuleStrategyService {
    static { BpamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    applicationCreateService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.BuildingPlans;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiBuildingPlansConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = BPExpandListForApplicationPartial;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    savedApplication;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, applicationSearchService, applicationCreateService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.applicationCreateService = applicationCreateService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_GET_MY_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationBpamsMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, BPExpandListForApplicationPartial);
    }
    buildListFilter(list, column) {
        const params = BpamsStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
            applicationType: application.applicationType,
            applicant: BpamsStrategyService_1.getRecipientName(BpamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: BpamsStrategyService_1.getRecipientName(BpamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate),
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
            sector: application.sector,
            isRdp: application.isRdp,
            buildingUse: application.buildingUse,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsBpamsComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationBpamsComponent,
            ],
            [
                ViewApplicationMenuHeadings.Notes,
                ViewApplicationNotesComponent,
            ],
            [
                ViewApplicationMenuHeadings.ProfessionalBodies,
                ViewApplicationProfessionalBodiesBpamsComponent,
            ]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationBpamsMenuHeadings.Location,
                CreateApplicationLocationBpamsComponent,
            ],
            [
                CreateApplicationBpamsMenuHeadings.Details,
                CreateApplicationDetailsBpamsComponent,
            ],
            [
                CreateApplicationBpamsMenuHeadings.Notes,
                CreateApplicationNotesComponent,
            ],
            [
                CreateApplicationBpamsMenuHeadings.ProfessionalBodies,
                CreateApplicationProfessionalBodiesBpamsComponent,
            ],
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_GET_ALL_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = BpamsStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, BpamsStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription =
            this.postApplicationService(application).subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(BpamsStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                    this.resetForm();
                    this.router.navigate([
                        AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")
                    ]).then();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
        this.form.get("detailsForm").get("isMinorBuildingWork").reset();
        this.form.get("detailsForm").get("isResidential").reset();
        this.form.get("detailsForm").get("buildingType").reset();
        this.form.get("detailsForm").get("isBuildingUseOther").reset();
        this.form.get("detailsForm").get("isAlterations").reset();
        this.form.get("detailsForm").get("sector").reset();
        this.form.get("detailsForm").get("isRdp").reset();
        this.form.get("detailsForm").get("buildingUse").reset();
        this.form.get("detailsForm").get("rdpHouseCount").reset();
        this.form.get("detailsForm").get("rdpHouseCount").disable();
        this.form.get("detailsForm").get("applicationType").reset();
        this.form.get("detailsForm").get("applicationEstimatedBy").reset();
        this.form.get("detailsForm").get("applicationEstimatedCost").reset();
        this.form.get("detailsForm").get("referenceNumber").reset();
        this.form.get("detailsForm").get("isResubmission").reset();
        this.form.get("detailsForm").get("isExtension").reset();
        this.form.get("detailsForm").get("previousReferenceNumber").reset();
        this.form.get("notesForm").get("note").reset();
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationBpamsMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication, missingLookupsForZones);
                break;
            case CreateApplicationBpamsMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpamsMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpamsMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpamsMenuHeadings.ProfessionalBodies.toLocaleLowerCase():
                application = this.buildProfessionalBodiesStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpamsMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationBpamsMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                bpApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest property owners
                    const params = {
                        $select: "properties,notes",
                        $expand: "properties($expand=owners($expand=groups),zonings,buildings),notes",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            savedApplication.properties = response.value[0]?.properties;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        },
                        complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(BpamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.bpApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(BpamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        application.elodgementStep = step.stepIndex;
        let owners = [];
        if (application.properties && application.properties.length > 0) {
            const propertiesArray = this.form.get("propertiesForm").get("properties");
            propertiesArray.controls.forEach((item) => {
                owners = item.get("owners").value ? item.get("owners").value : [];
                if (owners && owners.length > 0) {
                    owners = owners.map((owner) => {
                        owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                        return owner;
                    });
                }
            });
            application.properties[0].owners = owners;
        }
        this.creatResubmittedApplicationObservable(0, application, continueAfterSave).subscribe({
            next: (savedApplication) => {
                this.previousApplication = null;
                const params = {
                    $expand: this.expandListForApplicationPartial,
                    $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+savedApplication.moduleId}`
                };
                this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                    next: (response) => {
                        savedApplication.properties = response.value[0]?.properties;
                        if (continueAfterSave && !savedApplication.eLodgementComplete) {
                            --savedApplication.eLodgementStep;
                        }
                        this.savedApplication = savedApplication;
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                        this.requestStatusService.removeBusySpinner("continueToNextStep");
                    },
                    complete: () => {
                        if (this.savedApplication && continueAfterSave) {
                            this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                            this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                            this.appController.showMessage(AflaModuleStrategyService.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                        }
                        else {
                            // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                            // this.savedApplication.eLodgementStep = applicationRequestDto.bpApplication.eLodgementStep;
                            this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                            this.appController.showMessage(AflaModuleStrategyService.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                        }
                        this.requestStatusService.removeBusySpinner("continueToNextStep");
                        this.requestStatusService.removeBusySpinner("TrueCentroid");
                    }
                });
            }, error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                this.requestStatusService.removeBusySpinner("continueToNextStep");
            }
        });
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                isResubmission: false,
                isExtension: false,
                previousReferenceNumber: null,
            };
        }
        return application;
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${applicationId}/${ApiBuildingPlansConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, application, continueAfterSave) {
        const applicationRequestDto = {
            bpApplication: application,
            moveApplicationToNextStepAfterSave: continueAfterSave
        };
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${applicationId}/${ApiBuildingPlansConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationBpamsMenuHeadings.Location.toLocaleLowerCase():
                formName = "propertiesForm";
                break;
            case CreateApplicationBpamsMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationBpamsMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationBpamsMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationBpamsMenuHeadings.ProfessionalBodies.toLocaleLowerCase():
                formName = "professionalBodiesForm";
                break;
            case CreateApplicationBpamsMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            case CreateApplicationBpamsMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationBpamsMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("propertiesForm").get("properties").clear();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationBpamsMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").get("description").reset();
                this.form.get("detailsForm").get("isMinorBuildingWork").reset();
                this.form.get("detailsForm").get("isResidential").reset();
                this.form.get("detailsForm").get("buildingType").reset();
                this.form.get("detailsForm").get("isBuildingUseOther").reset();
                this.form.get("detailsForm").get("isAlterations").reset();
                this.form.get("detailsForm").get("sector").reset();
                this.form.get("detailsForm").get("isRdp").reset();
                this.form.get("detailsForm").get("buildingUse").reset();
                this.form.get("detailsForm").get("applicationType").reset();
                this.form.get("detailsForm").get("applicationEstimatedBy").reset();
                this.form.get("detailsForm").get("applicationEstimatedCost").reset();
                this.form.get("detailsForm").get("isResubmission").reset();
                this.form.get("detailsForm").get("isExtension").reset();
                this.form.get("detailsForm").get("previousReferenceNumber").reset();
                break;
            case CreateApplicationBpamsMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationBpamsMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationBpamsMenuHeadings.ProfessionalBodies.toLocaleLowerCase():
                this.form.get("professionalBodiesForm").get("architectRecipient").reset();
                this.form.get("professionalBodiesForm").get("engineerRecipients").reset();
                this.form.get("professionalBodiesForm").get("fireConsultantRecipients").reset();
                this.form.get("professionalBodiesForm").get("otherProfessionalRecipients").reset();
                this.form.get("professionalBodiesForm").get("electricalContractorRecipient").reset();
                this.form.get("professionalBodiesForm").get("markArchitectAsRequired").reset();
                this.form.get("professionalBodiesForm").get("markEngineerAsRequired").reset();
                this.form.get("professionalBodiesForm").get("markFireConsultantAsRequired").reset();
                this.form.get("professionalBodiesForm").get("markOtherProfessionalAsRequired").reset();
                this.form.get("professionalBodiesForm").get("markElectricalContractorAsRequired").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToArchitect").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToEngineer").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToFireConsultant").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToOtherProfessional").reset();
                this.form.get("professionalBodiesForm").get("copyApplicantToContractor").reset();
                break;
            case CreateApplicationBpamsMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            case CreateApplicationBpamsMenuHeadings.Notes.toLocaleLowerCase():
                this.form.get("notesForm").get("note").reset();
                break;
            default:
                break;
        }
    }
    postApplicationService(params) {
        return this.http.post(ApiBuildingPlansConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, properties, lastEditedUser, notes";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationBpamsMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationBpamsMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiBuildingPlansConstants.URL}/${jobId}/GetBpApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("propertiesForm") && this.form.get("propertiesForm").get("properties")) {
            const propertiesArray = this.form.get("propertiesForm").get("properties");
            if (propertiesArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage(CreateApplicationLocationBpamsConstants.PROPERTY_REQUIRED, AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage(CreateApplicationLocationBpamsConstants.PROPERTY_REQUIRED, AlertType.Warning);
            return false;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null)
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                isMinorBuildingWork: new FormControl(null, [Validators.required]),
                isResidential: new FormControl(null, [Validators.required]),
                buildingType: new FormControl("", [Validators.required]),
                isBuildingUseOther: new FormControl(false, [Validators.required]),
                isAlterations: new FormControl(null, [Validators.required]),
                sector: new FormControl(null, [Validators.required]),
                isRdp: new FormControl(null, [Validators.required]),
                rdpHouseCount: new FormControl({ value: null, disabled: true }, [Validators.pattern("[0-9]*")]),
                buildingUse: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                applicationEstimatedBy: new FormControl(null, [Validators.required]),
                applicationEstimatedCost: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null),
                isResubmission: new FormControl(null),
                isExtension: new FormControl(null),
                previousReferenceNumber: new FormControl(null),
            }),
            professionalBodiesForm: new FormGroup({
                sacapRegistrationNumber: new FormControl(null),
                architectRecipient: new FormControl(null),
                engineerRecipients: new FormControl(null),
                fireConsultantRecipients: new FormControl(null),
                otherProfessionalRecipients: new FormControl(null),
                electricalContractorRecipient: new FormControl(null),
                markArchitectAsRequired: new FormControl(null),
                markEngineerAsRequired: new FormControl(null),
                markFireConsultantAsRequired: new FormControl(null),
                markOtherProfessionalAsRequired: new FormControl(null),
                markElectricalContractorAsRequired: new FormControl(null),
                copyApplicantToArchitect: new FormControl(null),
                copyApplicantToEngineer: new FormControl(null),
                copyApplicantToContractor: new FormControl(null),
                copyApplicantToFireConsultant: new FormControl(null),
                copyApplicantToOtherProfessional: new FormControl(null)
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            }),
        });
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        return {
            id: existingApplication ? existingApplication.id : 0,
            decision: "",
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            isMinorBuildingWork: this.form.get("detailsForm").get("isMinorBuildingWork").value,
            isResidential: this.form.get("detailsForm").get("isResidential").value,
            buildingType: this.form.get("detailsForm").get("buildingType").value,
            isBuildingUseOther: this.form.get("detailsForm").get("isBuildingUseOther").value,
            isAlterations: this.form.get("detailsForm").get("isAlterations").value,
            sector: this.form.get("detailsForm").get("sector").value.value,
            isRdp: this.form.get("detailsForm").get("isRdp").value,
            rdpHouseCount: this.form.get("detailsForm").get("rdpHouseCount").value,
            buildingUse: this.form.get("detailsForm").get("buildingUse").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value.value,
            applicationEstimatedBy: this.form.get("detailsForm").get("applicationEstimatedBy").value.value,
            applicationEstimatedCost: this.form.get("detailsForm").get("applicationEstimatedCost").value,
            isResubmission: this.form.get("detailsForm").get("isResubmission").value,
            isExtension: this.form.get("detailsForm").get("isExtension").value,
            previousReferenceNumber: this.form.get("detailsForm").get("previousReferenceNumber").value,
            shape: "",
            wkid: 102100,
            applicant: applicant ? [applicant] : [],
            applicantAgent: [],
            architect: [],
            engineer: [],
            fireConsultant: [],
            otherProfessional: [],
            electricalContractor: [],
            properties: [],
            eLodgementComplete: false,
            eLodgementStep: 0
        };
    }
    buildLocationStep(stepIndex, existingApplication, missingLookupsForZones) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.properties = [];
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                properties: [],
                shape: "",
                wkid: 102100,
                isResubmission: false,
                isExtension: false,
                isAlterations: this.form.get("detailsForm").get("isBuildingUseOther").value ?? "",
                isResidential: this.form.get("detailsForm").get("isResidential").value ?? "",
                buildingType: this.form.get("detailsForm").get("buildingType").value ?? "",
                isBuildingUseOther: this.form.get("detailsForm").get("isBuildingUseOther").value ?? false,
                previousReferenceNumber: null,
            };
        // this should cover the copied applicant
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        if (applicantFormValue) {
            const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
            application.applicant = [applicant];
        }
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            let owners = item.get("owners").value ? item.get("owners").value : [];
            if (owners && owners.length > 0) {
                owners = owners.map((owner) => {
                    owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                    return owner;
                });
            }
            const property = {
                id: item.get("id").value,
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                erfSize: item.get("erfSize").value,
                farmNumber: item.get("farmNo").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                titleDeed: item.get("titleDeed").value,
                updateGeometry: false,
                wkid: 102100,
                applicationDescription: item.get("propertyDescription").value,
                applicationRestrictions: item.get("titleDeedRestrictions").value,
                externalWalls: item.get("externalWalls").value?.value,
                internalWalls: item.get("internalWalls").value?.value,
                roofing: item.get("roofing").value?.value,
                numberOfHouses: item.get("numberOfHousesUnits").value,
                patioCoveredExisting: item.get("coveredExisting").value,
                patioCoveredAdded: item.get("coveredAdded").value,
                patioOpenExisting: item.get("openExisting").value,
                patioOpenAdded: item.get("openAdded").value,
                pool: item.get("pool").value,
                boundaryWallHeight: item.get("boundaryWallHeight").value,
                boundaryWallRunning: item.get("boundaryWallRunning").value,
                coverage: item.get("coverage").value,
                bulkCalculation: item.get("bulkCalculation").value,
                zonings: [],
                buildings: [],
                owners,
            };
            // mainBuildings: new FormArray([], [Validators.min(1)]),
            const mainBuildingsArray = item.get("mainBuildings");
            mainBuildingsArray.controls.forEach((mainBuilding) => {
                const building = {
                    deleted: false,
                    type: "Main Building",
                    floor: mainBuilding.get("floor").value.toString(),
                    existingSize: mainBuilding.get("existingSize").value,
                    addedSize: mainBuilding.get("addedSize").value,
                    buildingNameNumber: mainBuilding.get("buildingNameNumber").value
                };
                property.buildings.push(building);
            });
            const outBuildingsArray = item.get("outBuildings");
            outBuildingsArray.controls.forEach((outBuilding) => {
                const building = {
                    deleted: false,
                    type: "Additional Building",
                    floor: outBuilding.get("floor").value.toString(),
                    existingSize: outBuilding.get("existingSize").value,
                    addedSize: outBuilding.get("addedSize").value,
                    buildingNameNumber: outBuilding.get("buildingNameNumber").value
                };
                property.buildings.push(building);
            });
            const propertyZonesArray = item.get("zones");
            propertyZonesArray?.controls.forEach((zoneItem) => {
                const zone = {
                    deleted: false,
                    zoning: zoneItem?.get("zone")?.value?.value,
                };
                property.zonings.push(zone);
            });
            // ensure that the existing zones that are not in a lookup (or form) are kept
            if (missingLookupsForZones) {
                missingLookupsForZones.forEach((missingZone) => {
                    const zone = {
                        deleted: false, zoning: missingZone,
                    };
                    property.zonings.push(zone);
                });
            }
            application.properties.push(property);
        });
        application.shape = `MULTIPOINT (${points.join(", ")})`;
        return application;
    }
    // TODO: Check Fields for BP_DETAILS
    buildDetailsStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.description = this.form.get("detailsForm").get("description").value;
            application.isMinorBuildingWork = this.form.get("detailsForm").get("isMinorBuildingWork").value;
            application.isResidential = this.form.get("detailsForm").get("isResidential").value;
            application.buildingType = this.form.get("detailsForm").get("buildingType").value;
            application.isBuildingUseOther = this.form.get("detailsForm").get("isBuildingUseOther").value;
            application.isAlterations = this.form.get("detailsForm").get("isAlterations").value;
            application.sector = this.form.get("detailsForm").get("sector").value;
            application.isRdp = this.form.get("detailsForm").get("isRdp").value;
            application.rdpHouseCount = this.form.get("detailsForm").get("rdpHouseCount").value;
            application.buildingUse = this.form.get("detailsForm").get("buildingUse").value;
            application.applicationType = this.form.get("detailsForm").get("applicationType").value;
            application.applicationEstimatedBy = this.form.get("detailsForm").get("applicationEstimatedBy").value;
            application.applicationEstimatedCost = this.form.get("detailsForm").get("applicationEstimatedCost").value;
            application.isResubmission = this.form.get("detailsForm").get("isResubmission").value;
            application.isExtension = this.form.get("detailsForm").get("isExtension").value;
            application.previousReferenceNumber = this.form.get("detailsForm").get("previousReferenceNumber").value;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                referenceNumber: "",
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: false,
                description: this.form.get("detailsForm").get("description").value,
                isMinorBuildingWork: this.form.get("detailsForm").get("isMinorBuildingWork").value,
                isResidential: this.form.get("detailsForm").get("isResidential").value,
                buildingType: this.form.get("detailsForm").get("buildingType").value,
                isBuildingUseOther: this.form.get("detailsForm").get("isBuildingUseOther").value,
                isAlterations: this.form.get("detailsForm").get("isAlterations").value,
                sector: this.form.get("detailsForm").get("sector").value,
                isRdp: this.form.get("detailsForm").get("isRdp").value,
                rdpHouseCount: this.form.get("detailsForm").get("rdpHouseCount").value,
                buildingUse: this.form.get("detailsForm").get("buildingUse").value,
                applicationType: this.form.get("detailsForm").get("applicationType").value,
                applicationEstimatedBy: this.form.get("detailsForm").get("applicationEstimatedBy").value,
                applicationEstimatedCost: this.form.get("detailsForm").get("applicationEstimatedCost").value,
                isResubmission: this.form.get("detailsForm").get("isResubmission").value,
                isExtension: this.form.get("detailsForm").get("isExtension").value,
                previousReferenceNumber: this.form.get("detailsForm").get("previousReferenceNumber").value,
            };
        return application;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = [applicant];
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: [applicant],
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                isResubmission: false,
                isExtension: false,
                previousReferenceNumber: null,
            };
        return application;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            application.applicantAgentNa = applicantAgentIsNullValue;
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicantAgent: applicantAgent ? [applicantAgent] : [],
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                isResubmission: false,
                isExtension: false,
                previousReferenceNumber: null,
            };
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return application;
    }
    buildProfessionalBodiesStep(stepIndex, existingApplication) {
        const architectIsRequired = this.form.get("professionalBodiesForm").get("markArchitectAsRequired").value;
        const engineerIsRequired = this.form.get("professionalBodiesForm").get("markEngineerAsRequired").value;
        const electricalContractorIsRequired = this.form.get("professionalBodiesForm").get("markElectricalContractorAsRequired").value;
        const fireConsultantIsRequired = this.form.get("professionalBodiesForm").get("markFireConsultantAsRequired").value;
        const otherProfessionalIsRequired = this.form.get("professionalBodiesForm").get("markOtherProfessionalAsRequired").value;
        if (architectIsRequired)
            this.form.get("professionalBodiesForm").get("architectRecipient").enable();
        if (engineerIsRequired)
            this.form.get("professionalBodiesForm").get("engineerRecipients").enable();
        if (electricalContractorIsRequired)
            this.form.get("professionalBodiesForm").get("electricalContractorRecipient").enable();
        if (fireConsultantIsRequired)
            this.form.get("professionalBodiesForm").get("fireConsultantRecipients").enable();
        if (otherProfessionalIsRequired)
            this.form.get("professionalBodiesForm").get("otherProfessionalRecipients").enable();
        const professionalBodiesArchitectFormValue = this.form.get("professionalBodiesForm").get("architectRecipient").value;
        const architect = RecipientUtils.removeInvalidRecipientProperties(professionalBodiesArchitectFormValue);
        const professionalBodiesEngineerFormValue = this.form.get("professionalBodiesForm").get("engineerRecipients").value;
        const engineer = RecipientUtils.removeInvalidRecipientProperties(professionalBodiesEngineerFormValue);
        const professionalBodiesFireConsultantFormValue = this.form.get("professionalBodiesForm").get("fireConsultantRecipients").value;
        const fireConsultant = RecipientUtils.removeInvalidRecipientProperties(professionalBodiesFireConsultantFormValue);
        const professionalBodiesOtherProfessionalFormValue = this.form.get("professionalBodiesForm").get("otherProfessionalRecipients").value;
        const otherProfessional = RecipientUtils.removeInvalidRecipientProperties(professionalBodiesOtherProfessionalFormValue);
        const professionalBodiesSelectElectricalContractorFormValue = this.form.get("professionalBodiesForm").get("electricalContractorRecipient").value;
        const electricalContractor = RecipientUtils.removeInvalidRecipientProperties(professionalBodiesSelectElectricalContractorFormValue);
        let application;
        application = existingApplication;
        application.architect = architectIsRequired ? [architect] : [];
        application.engineer = engineerIsRequired ? [engineer] : [];
        application.fireConsultant = fireConsultantIsRequired ? [fireConsultant] : [];
        application.otherProfessional = otherProfessionalIsRequired ? [otherProfessional] : [];
        application.electricalContractor = electricalContractorIsRequired ? [electricalContractor] : [];
        application.eLodgementStep = stepIndex;
        application.architectNa = !architectIsRequired;
        application.engineerNa = !engineerIsRequired;
        application.fireConsultantNa = !fireConsultantIsRequired;
        application.otherProfessionalNa = !otherProfessionalIsRequired;
        application.electricalContractorNa = !electricalContractorIsRequired;
        RecipientUtils.cleanPropertyOwners(application);
        return application;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true,
                isResubmission: false,
                isExtension: false,
                previousReferenceNumber: null,
            };
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER}`, params);
    }
    verifyExtensionReferenceNumberObservable(params) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_VERIFY_EXTENSION_REFERENCE_NUMBER}`, params);
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
BpamsStrategyService = BpamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsubPortal()
], BpamsStrategyService);
export { BpamsStrategyService };
